<template>
  <section class="pt-6 pb-14 px-6 sm:px-0 text-center">
    <h4 class="mb-6">
      We don't have any Special Offers based on your selected criteria.
    </h4>
    <h4 class="mb-6">
      Please adjust your selection or speak with a dive travel expert to help you find the perfect trip.
    </h4>

    <trengo-link>
      <template v-slot="{ openChat }">
        <div class="inline-flex sm:w-full">
          <button
            type="button"
            class="btn btn-primary flex items-center w-48 sm:w-full justify-center"
            @click="openChat()"
          >
            Chat With Us
          </button>
        </div>
      </template>
    </trengo-link>

  </section>
</template>

<script>
import TrengoLink from "../core/TrengoLink";

export default {
  components: {
    TrengoLink,
  },
};
</script>
